import type { CohortScope, FactScope, Filters, Territory } from '../types/dashboard';
import { territories } from '../data/territories';
import { PROGRAM_TYPES, SPORTS } from '../data/dimensions';
import { COMBO_COUNT, comboProgram, comboSport } from './combos';
import { LATEST_MONTH } from './calendar';

export const DEFAULT_FILTERS: Filters = {
  datePreset: 'last13',
  customStart: LATEST_MONTH - 12,
  customEnd: LATEST_MONTH,
  territories: [],
  aops: [],
  coach: 'all',
  sports: [],
  programs: [],
  seasons: [],
  years: [],
  source: 'All',
};

export function coachMatches(t: Territory, coach: string): boolean {
  if (coach === 'all') return true;
  const idx = coach.indexOf(':');
  const kind = coach.slice(0, idx);
  const name = coach.slice(idx + 1);
  return kind === 'fbc' ? t.fbc === name : t.ad === name;
}

export function resolveTerritoryIds(f: Filters): string[] {
  return territories
    .filter((t) => (f.territories.length === 0 || f.territories.includes(t.id)) && coachMatches(t, f.coach))
    .map((t) => t.id);
}

export function buildComboMask(sports: string[], programs: string[]): boolean[] {
  return Array.from(
    { length: COMBO_COUNT },
    (_, k) =>
      (sports.length === 0 || sports.includes(SPORTS[comboSport(k)])) &&
      (programs.length === 0 || programs.includes(PROGRAM_TYPES[comboProgram(k)]))
  );
}

export function makeScope(f: Filters, territoryIds: string[], aopIds: string[] | null): FactScope {
  return {
    territoryIds: new Set(territoryIds),
    aopIds: aopIds && aopIds.length ? new Set(aopIds) : null,
    source: f.source,
    comboMask: buildComboMask(f.sports, f.programs),
    seasons: f.seasons.length ? new Set(f.seasons) : null,
    years: f.years.length ? new Set(f.years.map(Number)) : null,
  };
}

export function makeCohortScope(f: Filters, territoryIds: string[], aopIds: string[] | null): CohortScope {
  return {
    territoryIds: new Set(territoryIds),
    aopIds: aopIds && aopIds.length ? new Set(aopIds) : null,
    comboMask: buildComboMask(f.sports, f.programs),
  };
}

export function registrationFiltersActive(f: Filters): boolean {
  return f.sports.length + f.programs.length + f.seasons.length + f.years.length > 0;
}
